import { Outlet, useLocation } from "react-router-dom";
import useGlobals from "@/utils/hooks/useGlobals.ts";
import PageHeading from "@/components/ui/PageHeading.tsx";
import { useEffect } from "react";
import DashboardContentLayout from "@/layouts/DashboardContentLayout.tsx";
import { useTranslation } from "react-i18next";

export default function MaterialsLayout() {
  const { setGlobalState } = useGlobals();
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    setGlobalState("backgroundClass", "bg-brand-background");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let filePage = false;

  if (location?.pathname.includes("file")) filePage = true;

  return (
    <DashboardContentLayout>
      {!filePage && (
        <PageHeading
          title={t("menu.materials")}
          titleClassName={"!text-light"}
          subtitleClassName={"!text-light"}
          subtitle={t("materials.sub_header")}
        />
      )}
      <Outlet />
    </DashboardContentLayout>
  );
}
